import { gql } from "~/__generated__"

export const MATCH_SOURCES = gql(/* GraphQL */ `
  mutation MatchSources {
    refreshSuggestions(input: {}) {
      run {
        id
        status
        error
        createdAt
      }
    }
  }
`)
export const SOURCE_DECISION = gql(/* GraphQL */ `
  mutation SourceDecision($input: SourceDecisionSaveInput!) {
    sourceDecisionSave(input: $input) {
      source {
        ...EditorialSource
      }
    }
  }
`)
